const drawRoundedRect = (context, x, y, width, height, radius) => {
  const r = Math.min(radius, width / 2, height / 2);
  context.beginPath();
  context.moveTo(x + r, y);
  context.lineTo(x + width - r, y);
  context.quadraticCurveTo(x + width, y, x + width, y + r);
  context.lineTo(x + width, y + height - r);
  context.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
  context.lineTo(x + r, y + height);
  context.quadraticCurveTo(x, y + height, x, y + height - r);
  context.lineTo(x, y + r);
  context.quadraticCurveTo(x, y, x + r, y);
  context.closePath();
};

const setFittedFont = (context, text, maxWidth, maxSize, minSize, family) => {
  let size = maxSize;
  do {
    context.font = `700 ${size}px ${family}`;
    size -= 2;
  } while (size >= minSize && context.measureText(text).width > maxWidth);
};

export const downloadTakeawayQrPoster = (qrBlob, restaurantName) => new Promise((resolve, reject) => {
  const qrObjectUrl = URL.createObjectURL(qrBlob);
  const qrImage = new Image();

  qrImage.onload = () => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = 1080;
      canvas.height = 1400;
      const context = canvas.getContext("2d");
      if (!context) throw new Error("Your browser cannot create the QR poster.");

      const restaurant = (restaurantName || "Restaurant").trim().toUpperCase();
      context.fillStyle = "#fbf3df";
      context.fillRect(0, 0, canvas.width, canvas.height);

      drawRoundedRect(context, 34, 34, 1012, 1332, 78);
      context.strokeStyle = "#a06f2c";
      context.lineWidth = 5;
      context.stroke();

      context.textAlign = "center";
      context.textBaseline = "middle";
      context.fillStyle = "#34271f";
      context.font = "700 58px Georgia, serif";
      context.fillText("HUNGRY?", 540, 116);
      context.font = "700 68px Georgia, serif";
      context.fillText("SCAN TO ORDER", 540, 190);

      context.strokeStyle = "#b48748";
      context.lineWidth = 3;
      context.beginPath();
      context.moveTo(170, 244);
      context.lineTo(910, 244);
      context.stroke();

      setFittedFont(context, restaurant, 760, 42, 26, "Arial, sans-serif");
      context.fillText(restaurant, 540, 292);

      drawRoundedRect(context, 140, 344, 800, 800, 54);
      context.fillStyle = "#ffffff";
      context.fill();
      context.strokeStyle = "#8a5b24";
      context.lineWidth = 4;
      context.stroke();
      context.imageSmoothingEnabled = false;
      context.drawImage(qrImage, 205, 409, 670, 670);

      context.fillStyle = "#6c5138";
      context.font = "600 27px Arial, sans-serif";
      context.fillText("SCAN  •  ORDER  •  PICK UP", 540, 1189);

      drawRoundedRect(context, 155, 1240, 770, 88, 16);
      context.fillStyle = "#49301f";
      context.fill();
      context.fillStyle = "#fffaf0";
      setFittedFont(context, "POWERED BY MENU ZYKA", 700, 35, 24, "Arial, sans-serif");
      context.fillText("POWERED BY MENU ZYKA", 540, 1284);

      const link = document.createElement("a");
      const safeName = (restaurantName || "Restaurant").replace(/[^a-z0-9-_]+/gi, "-");
      link.href = canvas.toDataURL("image/png");
      link.download = `${safeName}-Takeaway-QR.png`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      resolve();
    } catch (error) {
      reject(error);
    } finally {
      URL.revokeObjectURL(qrObjectUrl);
    }
  };

  qrImage.onerror = () => {
    URL.revokeObjectURL(qrObjectUrl);
    reject(new Error("QR code could not be added to the poster."));
  };
  qrImage.src = qrObjectUrl;
});
